import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Common/Navbar";
import Newsletter from "../../Components/Common/Newsletter";
import Footer from "../../Components/Common/Footer";
import { Box, Button, Typography, Divider, IconButton } from "@mui/material";
import google from "../../assets/Icons/googs.svg";
import facebook from "../../assets/Icons/Facebook.svg";
import apple from "../../assets/Icons/bi_apple.svg";
import { Link, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { useMutation, useLazyQuery } from "@apollo/client";
import { SIGNUP_SOCIAL } from "../../Utils/Mutations";
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch } from "react-redux";
import { setUserId } from "../../store/userSlice";
import { GET_COUNTRIES } from "../../Utils/Queries";
import useAuthFlow from "../../Hooks/use-auth-flow";
import { IoClose } from "react-icons/io5";
import RegisterEmailForm from "./register-email-form";

const SignupForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { switchAuth, onClose, triggerAuth } = useAuthFlow();
  const { enqueueSnackbar } = useSnackbar();
  const [accessToken, setAccessToken] = useState(null);

  const handleClickVariant = (variant, message) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(message, { variant });
  };

  const [getCountries, { loading, error, data: countryData }] =
    useLazyQuery(GET_COUNTRIES);

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      setAccessToken(tokenResponse?.access_token);
    },
  });
  const [googleAuth, { loading: googleLoader }] = useMutation(SIGNUP_SOCIAL);

 

  const handleGoogleAuth = async () => {
    try {
      const { data } = await googleAuth({
        variables: {
          accessToken: accessToken,
          socialAuthProviderKey: "GOOGLE_AUTH",
          useAccessToken: true,
          country: countryData?.getAllCountries?.items[0]?._id,
        },
      });

      dispatch(setUserId(data?.registerThroughSocialAuth?.userId));
      onClose();
      navigate("/createpin");
    } catch (err) {
      handleClickVariant("error", `${err.message}`);
     triggerAuth("signin")
    }
  };

  useEffect(() => {
    if (accessToken) {
      handleGoogleAuth();
    }
  }, [accessToken]);

  useEffect(() => {
    getCountries();
  }, []);

  const [emailForm, setEmailForm] = useState(false);

  return (
    <>
      <Box
        sx={{
          bgcolor: "#F8F7F7",
          borderRadius: "20px",
          width:{md: emailForm ? 600 : 470, xs:"100vw"},
          pb:{md:0, xs:5}
        }}
      >
        <Box
          sx={{
            margin: "0 auto",
            bgcolor: "#fff",
            borderRadius: "20px",
            px: 5,
            py: 3,
            mb: 4,
          }}
        >
          <div className="flex justify-between items-center">
            <div>
              <Typography
                sx={{ color: "#1a1a1a", fontWeight: 600, fontSize: "20px" }}
              >
                Create Your Account
              </Typography>
              <Typography
                sx={{ color: "#666", fontWeight: 400, fontSize: "13px" }}
              >
                Registration is easy.
              </Typography>
            </div>

            <div>
              <IconButton onClick={() => onClose()}>
                <IoClose className="text-black" />
              </IconButton>
            </div>
          </div>
          {emailForm ? (
            <>
              <RegisterEmailForm />
            </>
          ) : (
            <>
              <Box sx={{ mt: 3 }}>
                {googleLoader && (
                  <LoadingButton
                    disabled
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    sx={{
                      bgcolor: "#F8F7F7",
                      color: "#1a1a1a",

                      fontWeight: 400,
                      fontSize: "14px",
                      py: 2,
                      borderRadius: "50px",
                      height: "46px",
                    }}
                    fullWidth
                  >
                    {" "}
                    <img src={google} style={{ marginRight: "10px" }} />
                    Signing Up with Google
                  </LoadingButton>
                )}
                {!googleLoader && (
                  <Button
                    className="button"
                    onClick={loginGoogle}
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      py: 2,
                      borderRadius: "50px",
                      mt: 3,
                      height: "46px",
                    }}
                    variant="contained"
                    fullWidth
                  >
                    {" "}
                    <img src={google} style={{ marginRight: "10px" }} />
                    Sign Up with Google
                  </Button>
                )}
              </Box>
              <Divider sx={{ mt: 3 }}>
                <Typography>OR</Typography>
              </Divider>

              <Button
                onClick={() => setEmailForm(true)}
                className="button"
                sx={{
                  bgcolor: "#272727",
                  color: "#fff",

                  fontWeight: 400,
                  fontSize: "14px",
                  py: 2,
                  borderRadius: "50px",
                  height: "46px",
                  mt: 3,
                }}
                fullWidth
                size="large"
              >
                Sign Up with email
              </Button>
            </>
          )}

          <div className="mt-3 text-center">
            <span className="text-[12px]">
              Already have an account?{" "}
              <span
                onClick={() => switchAuth("signin")}
                className="text-primary font-bold cursor-pointer"
              >
                Login here
              </span>
            </span>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default SignupForm;
